import './App.css';
import { BrowserRouter as Router , Routes , Route } from 'react-router-dom';
import {Navbar} from "./components/navbar";
import Shop from "./pages/shop/shop";
import Cart from "./pages/cart/cart";
import Favorites from "./pages/favorites/favorites";
import { ShopContextProvider } from './context/shop-context';
import ProductDetail from './pages/detail/product-detail';
import { useDarkMode } from "./theme/DarkModeContext";
import DarkModeToggle from "./theme/DarkModeToggle";

function App() {
const { darkMode } = useDarkMode();
return (
<div className='App '>
  <div className={darkMode ? "dark" : "light" }>
    <ShopContextProvider>
   
      <Router>
        <Navbar />
        <Routes>
          <Route path='/' element={<Shop />}/>
          <Route path='/cart' element={<Cart />}/>
          <Route path='/favorites' element={<Favorites />}/>
          <Route path="/product/:id" element={<ProductDetail />} />
        </Routes>
       
      </Router>
    </ShopContextProvider>
  </div>
</div>
);
}

export default App;